import api from "../api";

// Equipment Register 
export const getEquipments = (params) =>
 api.get("/equipment", { params });

export const getEquipment = (id) =>
 api.get(`/equipment/${id}`);

export const createEquipment = (data) =>
 api.post("/equipment", data);

export const updateEquipment = (id, data) =>
 api.patch(`/equipment/${id}`, data);

export const deleteEquipment = (id) =>
 api.delete(`/equipment/${id}`);

// Stats & Reports 
export const getEquipmentStats = (params) =>
 api.get("/equipment/stats", { params });

export const getIdleReport = (params) =>
 api.get("/equipment/idle-report", { params });

export const getEquipmentRegister = (projectId) =>
 api.get(`/equipment/register/${projectId}`);

// Deployment Logs 
export const getDeploymentLogs = (params) =>
 api.get("/equipment/deployments", { params });

// Deployment Actions 
export const deployEquipment = (id, data) =>
 api.post(`/equipment/${id}/deploy`, data);

export const returnEquipment = (id, data) =>
 api.patch(`/equipment/${id}/return`, data);

export const logUtilization = (id, data) =>
 api.patch(`/equipment/${id}/utilization`, data);
